/*  商品管理  */
export default [
  {
    path: '/productManagementV1',
    name: 'productManagementV1',
    component: () => import('@/views/productManagement/index'),
    children: [
      {
        path: '/productManagement/productsInProgress',
        name: 'productsInProgress',
        component: () => import('@/views/productManagement/productsInProgress'),
      },
      // 历史商品数据
      {
        path: '/productManagement/historicalProductData',
        name: 'historicalProductData',
        component: () => import('@/views/productManagement/historicalProductData'),
      },
      // 信息维护
      {
        path: '/productManagement/informationMaintenance',
        name: 'informationMaintenance',
        component: () => import('@/views/productManagement/informationMaintenance'),
      },
      // 商品数据分析
      {
        path: '/productManagement/productDataAnalysis',
        name: 'productDataAnalysis',
        component: () => import('@/views/productManagement/productDataAnalysis'),
      },

    ]
  },
  // 商品管理 V2
  {
    path: '/productManagement',
    name: 'productManagementV2',
    component: () => import('@/views/productManagementV2'),
    meta: { title: '商品管理' },
  },
  {
    path: '/productManagement/detail',
    name: 'productManagementV2Detail',
    component: () => import('@/views/productManagementV2/detail'),
    meta: { title: '商品管理详情' },
  },
  // 信息维护详情
  {
    path: '/informationMaintenanceDetail',
    name: 'informationMaintenanceDetail',
    component: () => import('@/views/productManagement/informationMaintenance/informationMaintenanceDetail/index'),
  },
  //批量商品管理
  {
    path: '/batchProductManagement',
    name: 'batchProductManagement',
    component: () => import('@/views/productManagement/batchProductManagement/index'),
  },

]
